<template>
  <el-dialog
    class="dialogEditTopic"
    :visible="true"
    title="Tạo nhắc hẹn"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :show-close="false"
    width="407px">
    <div
      slot="title"
      class="font-16 fw-500 text-center">
      CHỈNH SỬA NHẮC HẸN
    </div>
    <div class="flex-column">
      <div
        class="mx-12 px-12 py-12 rounded-2"
        style="border: 1px solid #eaecf2">
        <div class="mb-2">
          Nhập nội dung
          <span class="text-red500">*</span>
        </div>
        <el-input
          type="textarea"
          resize="none"
          :rows="3"
          placeholder="Nhập nội dung hoặc dán liên kết"
          v-model="topic.title" />
        <div class="my-2">Chọn thời gian</div>
        <div class="d-flex justify-content-between align-items-center">
          <div
            v-for="item in quickTimeType"
            :key="item.val"
            class="z2-quicktime pointer px-2 py-1 font-13 fw-400"
            :class="item.val === quickTime && 'z2-quicktime-active'"
            @click="onChoseQuickTime(item.val)">
            {{ item.name }}
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div>
            <div class="my-2">Chọn ngày nhắc hẹn</div>
            <el-date-picker
              v-model="topic.startTime"
              type="datetime"
              placeholder="Chọn ngày nhắc hẹn"
              :disabled="quickTime !== 3"
              style="width: 224px !important"></el-date-picker>
          </div>
          <div>
            <div class="my-2">
              Lặp lại
              <span class="text-red500">*</span>
            </div>
            <el-select
              v-model="topic.repeat"
              style="width: 128px !important">
              <el-option
                v-for="(item, index) in repeatType"
                :key="index"
                :label="item.name"
                :value="item.val"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="d-flex mt-3 justify-content-between px-12 pb-3">
        <el-button
          type="danger"
          @click="cancelTopic">
          Hủy nhắc hẹn
        </el-button>
        <div>
          <el-button
            type="info"
            @click="$emit('close')">
            Hủy
          </el-button>
          <el-button
            type="primary"
            :disabled="!isHasChange || !topic.title || !topic.startTime || (topic.startTime < new Date().getTime() && topic.repeat === 0)"
            @click="updateTopic()">
            Lưu
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["conversation", "message"],
  data() {
    return {
      topic: {
        title: "",
        repeat: 0,
        startTime: 0,
      },
      quickTime: "",
    };
  },
  computed: {
    repeatType() {
      return [
        { name: "Không lặp lại", val: 0 },
        { name: "Hàng ngày", val: 1 },
        { name: "Hàng tuần", val: 2 },
        { name: "Hàng tháng", val: 3 },
      ];
    },
    quickTimeType() {
      return [
        { name: "15 phút nữa", val: 0 },
        { name: "30 phút nữa", val: 1 },
        { name: "9:00 ngày mai", val: 2 },
        { name: "Khác", val: 3 },
      ];
    },
    topicContent() {
      return this.message.content;
    },
    topicActionsParse() {
      return JSON.parse(JSON.parse(JSON.parse(JSON.parse(this.message.content).params).actions[0].data).data);
    },
    topicTitle() {
      if (this.conversation.group) {
        return JSON.parse(this.topicActionsParse.msg);
      }
      return this.topicActionsParse.params.title;
    },
    topicId() {
      if (this.conversation.group) {
        console.log(this.topicActionsParse, this.topicActionsParse.topicId);
        return this.topicActionsParse.topicId;
      }
      return this.topicActionsParse.reminderId;
    },
    isHasChange() {
      return (
        this.topic.title !== this.topicTitle || this.topic.repeat !== this.topicActionsParse.repeat || this.topic.startTime !== this.topicActionsParse.startTime
      );
    },
  },
  methods: {
    updateTopic() {
      if (!this.topic.title) {
        this.alert("error", "Nhập nội dung");
        return;
      }
      if (!this.topic.startTime) {
        this.alert("error", "Bạn chưa chọn thời gian");
        return;
      }
      // if (new Date(this.topic.startTime).getTime() < new Date().getTime()) {
      //   this.alert("error", "Nhập lại thời gian");
      //   return;
      // }

      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        startTime: new Date(this.topic.startTime).getTime(),
        title: this.topic.title,
        repeat: this.topic.repeat,
        reminderId: this.topicId,
      };
      this.$http.post(this.conversation.group ? "/api/message/updateGroupTopic" : "/api/message/updateTopic", request)
        .then((resp) => {
          const code = resp && resp.data && resp.data.error_code;
          if (code === -20017) {
            return this.alertError("Yêu cầu không thành công vì 2 bạn chưa kết bạn trên Zalo");
          }
          if (code === 166) {
            return this.alertError("Không đủ quyền chỉnh sửa nhắc hẹn.");
          }
          if (code === 112) {
            return this.alertError("Nhắc hẹn không tồn tại hoặc đã bị xóa.");
          }
          if (code && code !== 0) {
            return this.alertError((resp.data && resp.data.error_message) || "Có lỗi xảy ra, vui lòng thử lại.");
          }
          this.$emit("close", this.topic);
        })
        .catch(() => {
          this.alertError("Có lỗi xảy ra, vui lòng thử lại.");
        });
    },
    cancelTopic() {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        reminderId: this.topicId,
        group: this.conversation.group,
      };
      this.$http.post("/api/message/removeTopic", request).then(() => {
        this.$emit("close", this.topic);
      });
      this.$emit("close", this.topic);
    },
    onChoseQuickTime(type) {
      this.quickTime = type;
      const currentDate = new Date();
      currentDate.setSeconds(0);
      switch (type) {
        case 0: {
          this.topic.startTime = new Date(currentDate.getTime() + 15 * 60000);
          break;
        }
        case 1: {
          this.topic.startTime = new Date(currentDate.getTime() + 30 * 60000);
          break;
        }
        case 2: {
          currentDate.setDate(currentDate.getDate() + 1);
          currentDate.setHours(9, 0, 0, 0);
          this.topic.startTime = currentDate;
          break;
        }
        default:
          break;
      }
    },
  },
  mounted() {
    this.topic = {
      title: this.topicTitle,
      repeat: this.topicActionsParse.repeat,
      startTime: this.topicActionsParse.startTime,
    };
    this.quickTime = 3;
  },
};
</script>

<style lang="scss">
.dialogEditTopic {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.z2-quicktime {
  border: 1px solid #dcdfe9;
  border-radius: 4px;
  height: 32px;
}
.z2-quicktime-active {
  color: #1769d7;
  background-color: #e1edfd;
  border: none;
  font-weight: 500;
}
</style>